class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('.predictive-search');
    this.suggestions = document.querySelector('.search-modal__suggestions');
    this.autoplay = this.predictiveSearchResults.getAttribute('data-autoplay') || false;

    if(this.autoplay) this.onChange();

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 100).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.predictiveSearchResults.innerHTML = '';
      this.close();
      this.showSuggestions();
      return;
    }
    this.hideSuggestions();
    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`${routes.predictive_search_url}?q=${searchTerm}&resources[type]=product&resources[limit]=20&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.predictiveSearchResults.innerHTML = '';
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.predictiveSearchResults.innerHTML = '';
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  hideSuggestions() {
    if (this.suggestions) {
      this.suggestions.style.display = 'none';
    }
  }

  showSuggestions() {
    if (this.suggestions) {
      this.suggestions.style.display = '';
    }
  }
}

if(!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch);
}
